import { useState } from 'react';
import { VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material';
import { IconButton, InputAdornment, TextField } from '@mui/material';

import { PasswordInputType } from './props';

const PasswordInput = (props: PasswordInputType) => {
  const { onChange, value, name, ...restProps } = props;

  // ======================= STATE
  const [showPassword, setShowPassword] = useState(false);

  // ======================= VIEWS
  return (
    <TextField
      name={name}
      value={value}
      onChange={onChange}
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShowPassword(!showPassword)}
              onMouseDown={(e) => e.preventDefault()}
              edge="end"
            >
              {showPassword ? (
                <VisibilityOutlined />
              ) : (
                <VisibilityOffOutlined />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...restProps}
    />
  );
};

// ======================= EXPORT
export default PasswordInput;
